import React from "react";
import {withRouter} from "react-router";
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';
import APPCONFIG from "../../constants/Config";
import {Button, ButtonGroup} from "reactstrap";
import API from "@beardeddevops/react.api";
import {
	CASH_DISCOUNT_PAYMENT_TYPE_OPTIONS,
	parseCashDiscountPaymentTypes,
	stringifyCashDiscountPaymentTypes,
} from "../../utils/cashDiscountPaymentTypes";
import {locationCreditCardFeePercent} from "../../utils/ccFee";

class AccountCustomizations extends Framework.Components.Object {

	constructor(props) {
		/**
		 * @typedef {Accounts_Customizations_Object} this.state
		 */
		super(props, Types.Accounts_Customizations._name);
		this.noDelete = false;
	}

	cashDiscountTypeList = (object = this.state) => {
		return parseCashDiscountPaymentTypes(
			object.cash_discount_payment_types,
			!!object.allow_zelle,
			!!object.allow_debit
		);
	}

	setCashDiscountTypeList = (slugs, extra = {}) => {
		const next = {...this.state, ...extra};
		this.setState({
			...extra,
			cash_discount_payment_types: stringifyCashDiscountPaymentTypes(
				slugs,
				!!next.allow_zelle,
				!!next.allow_debit
			),
		});
	}

	handleAllowPaymentTypeToggle = (property, value) => {
		this.handleTextFieldPropertyUpdate(property, value);
		const name = property?.name;
		const extra = {[name]: value};
		this.setCashDiscountTypeList(this.cashDiscountTypeList({...this.state, ...extra}), extra);
	}

	toggleCashDiscountPaymentType = (slug, checked) => {
		if (slug === 'cash') {
			return;
		}
		const current = this.cashDiscountTypeList();
		const next = checked
			? Array.from(new Set([...current, slug]))
			: current.filter((item) => item !== slug);
		this.setCashDiscountTypeList(next);
	}

	ensureUseNewSidenavProperty = () => {
		if (!this.model.properties.use_new_sidenav) {
			this.model.properties.use_new_sidenav = {
				name: 'use_new_sidenav',
				settable: true,
				queryable: false,
				type: 'bool',
			};
		} else {
			this.model.properties.use_new_sidenav.settable = true;
		}
	}

	applyUseNewSidenav = (value) => {
		const useNew = !!value;
		this.setState({use_new_sidenav: useNew, use_new_sidenav_error: ''});
		window.localStorage.setItem('override_new_sidenav', useNew ? '1' : '0');
		window.dispatchEvent(new CustomEvent('bpos-use-new-sidenav', {detail: useNew}));
	}

	loadSelfAfter = (data) => {
		const override = window.localStorage.getItem('override_new_sidenav');
		if (override === '1' || override === 'true') {
			this.setState({use_new_sidenav: true});
			return;
		}
		if (override === '0' || override === 'false') {
			this.setState({use_new_sidenav: false});
			return;
		}
		if (data && typeof data.use_new_sidenav !== 'undefined') {
			this.setState({use_new_sidenav: !!data.use_new_sidenav});
		}
	}

	handleSubmit = async (event, suppressToast = false, suppressProcess = false) => {
		this.ensureUseNewSidenavProperty();
		this.state.use_new_sidenav = !!this.state.use_new_sidenav;
		return super.handleSubmit(event, suppressToast, suppressProcess);
	}

	afterSubmit = () => {
		window.localStorage.setItem('override_new_sidenav', this.state.use_new_sidenav ? '1' : '0');
		window.location.reload();
	}

	//delete only the logo
	deleteLogo = () => {
		let modelLogo = new API.BuildClass(Types.Accounts_Customizations._name, API.RequestType.DELETE);
		modelLogo.submit(null, 'DELETE_LOGOS').then( () => {
			//reload the tab
			this.props.history.push('/');
			this.props.history.push('/settings#customizations');
		});

	}

	form = () => {
		/**
		 *  @param {Accounts_Customizations_Properties} data
		 */
		let {properties} = this.model;
		/**
		 *  @type {Accounts_Customizations_Object} object
		 */
		let object = this.state;
		const ccFeePercent = locationCreditCardFeePercent(this.props.rootState?.location);
		const hasCcFee = ccFeePercent > 0;
		const applyCcFeeToDebitSwitch = (
			<Framework.Elements.ButtonSwitch
				value={hasCcFee ? (object.apply_cc_fee_to_debit == null ? true : object.apply_cc_fee_to_debit) : false}
				error={object.apply_cc_fee_to_debit_error}
				property={properties.apply_cc_fee_to_debit}
				update={hasCcFee ? this.handleTextFieldPropertyUpdate : undefined}
				disabled={!hasCcFee}
				labelTrue={"Yes"}
				labelFalse={"No"}
				project={'pos'}
			/>
		);
		const autoCcFeeSwitch = (
			<Framework.Elements.ButtonSwitch
				value={hasCcFee ? object.auto_cc_fee : false}
				error={object.auto_cc_fee_error}
				property={properties.auto_cc_fee}
				update={hasCcFee ? this.handleTextFieldPropertyUpdate : undefined}
				disabled={!hasCcFee}
				labelTrue={"Yes"}
				labelFalse={"No"}
				project={'pos'}
			/>
		);

		return(
			<div className={'form-group'}>
				<div className={'row'}>
					<div className={'col-6'}>
						<div>
							<h4 className="section-title">Custom Receipt Options</h4>
							<form>
								<fieldset>
									<div className="form-group">
										<Framework.Elements.TextField
											name={"message"}
											label={"Custom Message"}
											property={properties.message}
											value={object.message ?? ""}
											error={object.message_error}
											multiline={6}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											name={"warranty"}
											label={"Warranty Information"}
											property={properties.warranty}
											value={object.warranty}
											error={object.warranty_error}
											multiline={3}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
									<div className="form-group">
										<Framework.Elements.TextField
											name={"return_policy"}
											label={"Return Policy Information"}
											property={properties.return_policy}
											value={object.return_policy}
											error={object.return_policy_error}
											multiline={3}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>

									{/*#region License Image Upload*/}
									<h4 className="section-title">Logo Upload</h4>

									<div className={"form-group"}>
										<p>
											Upload a copy of your logo.<br/>
											{object.logo ?
												<span>Current Logo - <b>{object.logo}</b><br/><i>Upload a new
													file to
													replace the old one.</i></span>
												: null}
										</p>
										<Framework.Elements.DropZone
											property={properties.logo}
											value={object.logo}
											error={object.logo_error}
											update={this.handleFileChange}
										/>
									</div>
									{object.logo && object.pkey &&
										<div>
											<div style={{textAlign: "center"}}>
												<img
													src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/accounts/customizations/image'}
													alt={object.logo}
													style={{maxWidth: '100%', height: '300px'}}
												/>
											</div>
											<br></br>
											<div style={{textAlign: "-webkit-center"}}>
												<Button color="danger"
												        onClick={() => this.deleteLogo()}
												        size={"md"} block={true}
												        style={{width: "fit-content"}}>
													Delete Logo
												</Button>
											</div>
										</div>
									}
									{(object.account === 183 || object.account === 10) && (
										<>
											<h4 className="section-title">Set Max Quantity for Year End Reports</h4>
											<div className="form-group">
												<Framework.Elements.TextField
													name={"warranty"}
													label={"Max Quantity"}
													property={properties.max_quantity}
													value={object.max_quantity}
													error={object.max_quantity_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</>
									)}
									{/*#endregion*/}
								</fieldset>
							</form>
						</div>
					</div>
					<div className={'col-6'}>
						<h4 className="section-title">Checkout Options</h4>
						{/*<b style={{textAlign: 'center', display: 'flex', fontStyle: 'italic', paddingBottom: '10px'}}>Do*/}
						{/*	you want to use the newest checkout features?</b>*/}
						{/*<div className={'form-group'}>*/}
						{/*	<b>Use New Checkout</b>*/}
						{/*	<Framework.Elements.ButtonSwitch*/}
						{/*		value={object.new_checkout}*/}
						{/*		error={object.new_checkout_error}*/}
						{/*		property={properties.new_checkout}*/}
						{/*		update={this.handleTextFieldPropertyUpdate}*/}
						{/*		labelTrue={"Yes"}*/}
						{/*		labelFalse={"No"}*/}
						{/*	/>*/}
						{/*</div>*/}
						<div className={'form-group'}>
							<b>Allow Zelle at Checkout</b>
							<Framework.Elements.ButtonSwitch
								value={object.allow_zelle}
								error={object.allow_zelle_error}
								property={properties.allow_zelle}
								update={this.handleAllowPaymentTypeToggle}
								labelTrue={"Yes"}
								labelFalse={"No"}
								project={'pos'}
							/>
						</div>
						<div className={'form-group'}>
							<b>Allow Debit Card at Checkout</b>
							<Framework.Elements.ButtonSwitch
								value={object.allow_debit}
								error={object.allow_debit_error}
								property={properties.allow_debit}
								update={this.handleAllowPaymentTypeToggle}
								labelTrue={"Yes"}
								labelFalse={"No"}
								project={'pos'}
							/>
						</div>
						<div className={'form-group'}>
							<b>Use Cash Discounting</b>
							<div style={{display: 'flex', flexDirection: 'row', gap: 5, paddingTop: 5}}>
								<Framework.Elements.ButtonSwitch
									value={object.cash_discounting}
									error={object.cash_discounting_error}
									property={properties.cash_discounting}
									update={this.handleTextFieldPropertyUpdate}
									labelTrue={"Yes"}
									labelFalse={"No"}
									project={'pos'}
								/>
								{object.cash_discounting &&
									<div className="form-group">
										<Framework.Elements.TextField
											name={"cash_discount_percentage"}
											label={"Discount Percentage"}
											property={properties.cash_discount_percentage}
											value={object.cash_discount_percentage}
											error={object.cash_discount_percentage_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>}
							</div>
							{object.cash_discounting &&
								<div className="form-group" style={{marginTop: 10}}>
									<b>Apply cash discount to</b>
									<div style={{display: 'flex', flexDirection: 'column', gap: 6, paddingTop: 8}}>
										{CASH_DISCOUNT_PAYMENT_TYPE_OPTIONS.filter((option) => {
											if (option.requiresAllow === 'allow_zelle') {
												return !!object.allow_zelle;
											}
											if (option.requiresAllow === 'allow_debit') {
												return !!object.allow_debit;
											}
											return true;
										}).map((option) => {
											const selected = this.cashDiscountTypeList();
											const checked = selected.includes(option.slug);
											return (
												<label key={option.slug} style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 0, accentColor: '#16a34a'}}>
													<input
														type="checkbox"
														checked={checked}
														disabled={!!option.locked}
														onChange={(event) => this.toggleCashDiscountPaymentType(option.slug, event.target.checked)}
													/>
													<span>{option.label}{option.locked ? ' (required)' : ''}</span>
												</label>
											);
										})}
									</div>
								</div>}
						</div>
						<div className={'form-group'}>
							<b>Auto Apply Credit Card Fee</b>
							<b style={{textAlign: 'center', display: 'flex', fontStyle: 'italic', paddingBottom: '10px'}}>
								{hasCcFee
									? `Automatically apply the Credit Card Fee (${ccFeePercent.toFixed(2)}%) to card payments at checkout.`
									: 'Automatically apply the Credit Card Fee to card payments at checkout.'}
							</b>
							{hasCcFee ? autoCcFeeSwitch : (
								<Tooltip
									title="This setting is disabled because no Credit Card Fee is set on the current location."
									placement="top"
								>
									<span style={{display: 'inline-block'}}>
										{autoCcFeeSwitch}
									</span>
								</Tooltip>
							)}
						</div>
						<div className={'form-group'}>
							<b>Apply CC Fee to Debit Card</b>
							<b style={{textAlign: 'center', display: 'flex', fontStyle: 'italic', paddingBottom: '10px'}}>
								When Yes, debit card checkout uses the same Credit Card Fee as credit. When No, debit is not charged a CC fee.
							</b>
							{hasCcFee ? applyCcFeeToDebitSwitch : (
								<Tooltip
									title="This setting is disabled because no Credit Card Fee is set on the current location."
									placement="top"
								>
									<span style={{display: 'inline-block'}}>
										{applyCcFeeToDebitSwitch}
									</span>
								</Tooltip>
							)}
						</div>
						<div className={'form-group'}>
							<b>Auto Apply Credit Card Fee</b>
							<b style={{textAlign: 'center', display: 'flex', fontStyle: 'italic', paddingBottom: '10px'}}>
								{hasCcFee
									? `Automatically apply the Credit Card Fee (${ccFeePercent.toFixed(2)}%) to card payments at checkout.`
									: 'Automatically apply the Credit Card Fee to card payments at checkout.'}
							</b>
							{hasCcFee ? autoCcFeeSwitch : (
								<Tooltip
									title="This setting is disabled because no Credit Card Fee is set on the current location."
									placement="top"
								>
									<span style={{display: 'inline-block'}}>
										{autoCcFeeSwitch}
									</span>
								</Tooltip>
							)}
						</div>
						<h4 className="section-title">Invoicing (local tracking)</h4>
						<b style={{textAlign: 'center', display: 'flex', fontStyle: 'italic', paddingBottom: '10px'}}>
							Track &quot;To Invoice&quot; sales in /invoices — open balances, payments, and write-offs.
							For emailed pay links and card pay, enable AltruPay pay-by-link under Settings → Integrations.
						</b>
						<div className={'form-group'}>
							<b>Enable Local Invoicing</b>
							<Framework.Elements.ButtonSwitch
								value={object.invoicing_enabled}
								error={object.invoicing_enabled_error}
								property={properties.invoicing_enabled}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={"Yes"}
								labelFalse={"No"}
								project={'pos'}
							/>
						</div>
						{object.invoicing_enabled &&
							<div className={'form-group'}>
								<b>Automatically Create Invoice on Checkout</b>
								<Framework.Elements.ButtonSwitch
									value={object.auto_invoice}
									error={object.auto_invoice_error}
									property={properties.auto_invoice}
									update={this.handleTextFieldPropertyUpdate}
									labelTrue={"Yes"}
									labelFalse={"No"}
									project={'pos'}
								/>
							</div>}

						<h4 className="section-title">Receipt Options</h4>
						<b style={{textAlign: 'center', display: 'flex', fontStyle: 'italic', paddingBottom: '10px'}}>
							Customize what your receipts show and how they print.</b>
						<div className={'form-group'}>
							<b>Customer's Info</b>
							<Framework.Elements.ButtonSwitch
								value={object.show_customer_info}
								error={object.show_customer_info_error}
								property={properties.show_customer_info}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={"Show"}
								labelFalse={"Hide"}
								project={'pos'}
							/>
						</div>
						<div className={'form-group'}>
							<b>Tax Rate Breakdown</b>
							<Framework.Elements.ButtonSwitch
								value={object.show_tax_breakdown}
								error={object.show_tax_breakdown_error}
								property={properties.show_tax_breakdown}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={"Show"}
								labelFalse={"Hide"}
								project={'pos'}
							/>
						</div>
						<div className={'form-group'}>
							<b>Skip Print Preview</b>
							<Framework.Elements.ButtonSwitch
								value={object.skip_print_preview}
								error={object.skip_print_preview_error}
								property={properties.skip_print_preview}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={"Yes"}
								labelFalse={"No"}
								project={'pos'}
							/>
						</div>

						<h4 className="section-title">Sidenav Style</h4>
						<b style={{textAlign: 'center', display: 'flex', fontStyle: 'italic', paddingBottom: '10px'}}>Which navigation menu would you like to use?</b>
						<div className={'form-group'}>
							<b>New Sidenav</b>
							<Framework.Elements.ButtonSwitch
								value={object.use_new_sidenav}
								error={object.use_new_sidenav_error}
								property={properties.use_new_sidenav}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={"New"}
								labelFalse={"Old"}
								project={'pos'}
							/>
						</div>
						<h4 className="section-title">Sidenav Options</h4>
						<b style={{textAlign: 'center', display: 'flex', fontStyle: 'italic', paddingBottom: '10px'}}>Do
							you want these options shown in the navigation menu?</b>
						<div className={'form-group'}>
							<b>Consignments</b>
							<Framework.Elements.ButtonSwitch
								value={object.show_consignments}
								error={object.show_consignments_error}
								property={properties.show_consignments}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={"Show"}
								labelFalse={"Hide"}
								project={'pos'}
							/>
						</div>
						<div className={'form-group'}>
							<b>Layaways</b>
							<Framework.Elements.ButtonSwitch
								value={object.show_layaways}
								error={object.show_layaways_error}
								property={properties.show_layaways}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={"Show"}
								labelFalse={"Hide"}
								project={'pos'}
							/>
						</div>
						<div className={'form-group'}>
							<b>Trade-Ins</b>
							<Framework.Elements.ButtonSwitch
								value={object.show_trade_ins}
								error={object.show_trade_ins_error}
								property={properties.show_trade_ins}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={"Show"}
								labelFalse={"Hide"}
								project={'pos'}
							/>
						</div>
						{this.props.rootState.ffl_boss_linked && (
						<>
						<h4 className="section-title">FFL Boss Options</h4>
						<b style={{textAlign: 'center', display: 'flex', fontStyle: 'italic', paddingBottom: '10px'}}>Do you want to sync your customers with FFL Boss?</b>
						<div className={'form-group'}>
							<b>FFL Boss Customer Sync</b>
							<Framework.Elements.ButtonSwitch
								value={object.ffl_customer_copy}
								error={object.ffl_customer_copy_error}
								property={properties.ffl_customer_copy}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={"Yes"}
								labelFalse={"No"}
								project={'pos'}
							/>
						</div>
						<div className={'form-group'}>
							<b>Force FFLBoss Products Taxable</b>
							<b style={{textAlign: 'center', display: 'flex', fontStyle: 'italic', paddingBottom: '10px'}}>
								Ignore FFLBoss non-taxable flags when adding products in POS. Cashiers can still mark a line Non-Taxable.
							</b>
							<Framework.Elements.ButtonSwitch
								value={object.ffl_force_taxable}
								error={object.ffl_force_taxable_error}
								property={properties.ffl_force_taxable}
								update={this.handleTextFieldPropertyUpdate}
								labelTrue={"Yes"}
								labelFalse={"No"}
								project={'pos'}
							/>
						</div>
						</>
						)}
					</div>
				</div>
			</div>
		)
	}
}

export default Framework.Components.withRootState(withRouter(AccountCustomizations));
